import { useQuery } from "@tanstack/react-query";
import { Scenario } from "@/model";
import scenarioRepository from "@/repository/scenarioRepository";
import { scenarioQueryKeys } from "./keys";


const getData = async (id?: string) => {
    if (!id) {
        return null;
    }
    const response = await scenarioRepository.read(id);
    return response.data;
};

export const useScenario = (id?: string) => {
    return useQuery<Scenario>({
        queryKey: scenarioQueryKeys.detail(id ?? ""),
        queryFn: () => getData(id)
    });
};
